import React from 'react'
import PropTypes from 'prop-types'

export default function BottomLeftVignette ({ fill, ...others }) {
  return (
    <svg
      width="463"
      height="370"
      viewBox="0 0 463 370"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...others}
      aria-hidden="true"
    >
      <g opacity="0.5">
        <circle
          cx="45.9162"
          cy="45.9162"
          r="45.9162"
          transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 184.666 185.205)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle
          cx="20.9174"
          cy="20.9174"
          r="20.9174"
          transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 159.668 210.204)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 184.666 93.3733)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 369.838 277.037)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 92.832 277.037)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <rect
          width="91.8323"
          height="91.8323"
          transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 92.832 1)"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M234.881 185C258.602 185 277.832 204.23 277.832 227.951L277.832 277L184.832 277L184.832 185L234.881 185Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M277.843 368.972V276.978H184.826L277.843 368.972Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M184.827 276.978L184.827 368.972L277.844 368.972L184.827 276.978Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M92.834 368.869L184.666 368.869L184.666 277.037L92.834 368.869Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M370 276.978L370 368.81L461.832 368.81L370 276.978Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M92.832 277V185H1.83203L92.832 277Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M184.666 277.037L92.8337 277.037L92.8337 368.87L184.666 277.037Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M92.832 92.9999L0.999714 92.9999L0.999707 184.832L92.832 92.9999Z"
          stroke={fill}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

BottomLeftVignette.defaultProps = {
  fill: '#DEF3F7',
}

BottomLeftVignette.propTypes = {
  fill: PropTypes.string,
}
